import gql from 'graphql-tag';

export const manuallyApproveSnapchatMutation = gql`
  mutation manuallyRespondToSnapchat($approvalId: String!, $approve: Boolean!, $username: String) {
    manuallyRespondToSnapchat(approvalId: $approvalId, approve: $approve, username: $username)
  }
`;
